import { useLazyQuery } from '@apollo/client'
import { PipelineItemType } from '@flowwai-frontend/bps-officer-web/graphql'

import {
   GetPinnedPipelineItemsCountForUserQuery as Query,
   GetPinnedPipelineItemsCountForUserQueryVariables as QueryVariables,
   GetPinnedPipelineItemsCountForUserDocument as QueryDocument
} from './query.generatedTypes'

interface ReturnType {
   triggerAPI: (onSuccess?: (count: number) => void) => void
}

const useGetPinnedPipelineItemsCountForUser = (): ReturnType => {
   const [getPinnedPipelineItemsCount] = useLazyQuery<Query, QueryVariables>(
      QueryDocument,
      { fetchPolicy: 'cache-first' }
   )

   const triggerAPI = (onSuccess?: (count: number) => void): void => {
      getPinnedPipelineItemsCount({
         variables: {
            params: {
               pipelineItemTypes: [
                  PipelineItemType.Lead,
                  PipelineItemType.Deal,
                  PipelineItemType.CustomObject,
                  PipelineItemType.Application
               ]
            }
         },
         onCompleted: (data: Query) => {
            if (onSuccess)
               onSuccess(data.getPinnedPipelineItemsCountForUser.totalCount)
         }
      })
   }

   return { triggerAPI }
}

export default useGetPinnedPipelineItemsCountForUser
